import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=2f46c6ac&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"
import style0 from "./Messages.vue?vue&type=style&index=0&id=2f46c6ac&prod&lang=scss&scoped=true"
import style1 from "./Messages.vue?vue&type=style&index=1&id=2f46c6ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f46c6ac",
  null
  
)

export default component.exports